
import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import owner from '../../../assets/assets-homepage/img/owner.webp';
import { EXTERNAL_LINKS } from '../../../constants';
export default function Founder() {
  const { t } = useTranslation('home');
  const [more, setMore] = useState(true)
  return (
    <div className="founder lg:!py-[60px] sm:!py-10 !py-8">
      <div className="container">
        <h2 className="section-heading text-center mb-2.5 sm:mb-8 lg:mb-11">{t('founder.heading')}</h2>
      </div>

      <div className="founder_sec1">
        <div className="container">
          <div className="founder__photo">
            <div>
              <img src={owner} />
            </div>
          </div>
        </div>
      </div>

      <div className="founder__text">
        <div className="container">
          <div className="!max-w-[890px] text-center text-[#4A4A4A] mx-auto !text-xs sm:!text-base lg:!text-lg ">
            <p className='lg:!leading-[30px] sm:!leading-[26px] !leading-[18px] max-w-[331px] mx-auto sm:max-w-full'>
              <span className={more ? "moretext moretext_show" : "moretext"}>
                <Trans
                  i18nKey="founder.body"
                  ns="home"
                  components={{
                    strong1: <strong />,
                    strong2: <strong />,
                    strong3: <strong />,
                    strong4: <strong />,
                    br1: <br />,
                    a1: <a href={EXTERNAL_LINKS.FOUNDER_INSTAGRAM} target="_blank" rel="noopener noreferrer">i</a>,
                  }}
                />
              </span>
              {!more && <span className="readmore" onClick={() => setMore(true)}>+</span>}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
